import React from 'react';

import CompaniesPage from '../components/CompaniesPage';

const Companies = () => (
  <CompaniesPage
    lang="es"
    title="Empresas asociadas | Full Stack open"
    seoDescription="Desarrollo Full Stack en empresas asociadas"
  />
);

export default Companies;
